import { createSlice } from '@reduxjs/toolkit';
import companyEndpoints from 'app/api/services/companyEndpoints';
import lineEndpoint from 'app/api/services/lineEndpoint';
import licenseEndpoint from 'app/api/services/licenseEndpoint';
import requestEndpoints from 'app/api/services/requestEndpoints';
import userEndpoints from 'app/api/services/userEndpoints';
import vehiclesEndpoint from 'app/api/services/vehiclesEndpoint';
import { errorHandler } from 'app/utils/errorHandler';

const initialState = {
  companyTypes: [],
  companyTypesGeneral: [],
  personTypes: [],
  industry: [],
  activeCompany: {},
  vehicles: [],
  infractions: [],
  licenses: [],
  lines: [],
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyTypes(state, action) {
      state.companyTypes = action.payload;
    },
    clearCompanyTypes(state, action) {
      state.companyTypes = initialState.companyTypes;
    },
    setCompanyTypesGeneral(state, action) {
      state.companyTypesGeneral = action.payload;
    },
    clearCompanyTypesGeneral(state, action) {
      state.companyTypesGeneral = initialState.companyTypesGeneral;
    },
    setPersonTypes(state, action) {
      state.personTypes = action.payload;
    },
    clearPersonTypes(state, action) {
      state.personTypes = initialState.companyTypes;
    },
    setIndustry(state, action) {
      state.industry = action.payload;
    },
    clearIndustry(state, action) {
      state.industry = initialState.industry;
    },
    setActiveCompany(state, action) {
      state.activeCompany = action.payload;
    },
    clearActiveCompany(state, action) {
      state.activeCompany = initialState.activeCompany;
    },
    setCompanyVehicles(state, action) {
      state.vehicles = action.payload;
    },
    clearCompanyVehicles(state, action) {
      state.vehicles = initialState.vehicles;
    },
    setCompanyInfractions(state, action) {
      state.infractions = action.payload;
    },
    clearCompanyInfractions(state, action) {
      state.infractions = initialState.infractions;
    },
    setCompanyLicenses(state, action) {
      state.licenses = action.payload;
    },
    clearCompanyLicenses(state, action) {
      state.licenses = initialState.licenses;
    },
    setCompanyLines(state, action) {
      state.lines = action.payload;
    },
    clearCompanyLines(state, action) {
      state.lines = initialState.lines;
    },
  },
});

export const fecthAllCompanyTypes = () => async dispatch => {
  let response = [];
  try {
    response = await companyEndpoints.getCompanyTypes();
    dispatch(setCompanyTypes(response.data ? response.data : []));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fecthAllCompanyTypesGeneral = () => async dispatch => {
  let response = [];
  try {
    response = await companyEndpoints.getCompanyTypesGeneral();
    dispatch(setCompanyTypesGeneral(response.data ? response.data : []));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fecthAllPersonTypes = () => async dispatch => {
  let response = [];
  try {
    response = await companyEndpoints.getPersonTypes();
    dispatch(setPersonTypes(response.data ? response.data : []));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fecthAllIndustry = () => async dispatch => {
  let response = [];
  try {
    response = await companyEndpoints.getIndustry();
    dispatch(setIndustry(response.data ? response.data : []));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchVehicles = (params, context) => async dispatch => {
  try {
    let response = [];
    response = await vehiclesEndpoint.getVehicles(params, context);
    dispatch(setCompanyVehicles(response.data));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchLicenses = (params, context) => async dispatch => {
  try {
    let response = [];
    response = await licenseEndpoint.getLicenses(params, context);
    dispatch(setCompanyLicenses(response.data));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchLines = (params, context) => async dispatch => {
  try {
    let response = [];
    response = await lineEndpoint.getLines(params, context);
    dispatch(setCompanyLines(response.data));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchInfractions = (params, context) => async dispatch => {
  try {
    let response = [];
    response = await vehiclesEndpoint.getInfractions(params, context);
    dispatch(setCompanyInfractions(response.data));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const searchCompanyNameAndDocument = async cdSolicitacao => {
  try {
    const response = await requestEndpoints.findRequest({
      cdSolicitacao: cdSolicitacao,
    });
    if (response.status === 200 && response.data) {
      const solic = response.data;
      if (solic.cdUsuarioSolicitacao) {
        const responseUser = await userEndpoints.getUserInformations(solic.cdUsuarioSolicitacao);
        if (responseUser.status === 200 && responseUser.data) {
          const dataUser = responseUser.data;
          const tempName =
            dataUser.deRazaoSocial || dataUser.nmCompleto || dataUser.nmUsuario || '';
          const tempDocument = dataUser.deCnpjMatriz || dataUser.deCpfCnpj || dataUser.deCpf || '';

          return { name: tempName, document: tempDocument };
        }
      }
    }
  } catch (error) {}
  return {};
};

export const searchCompanyNameAndDocumentByCdUsuario = async cdUsuarioSolicitacao => {
  try {
    if (cdUsuarioSolicitacao) {
      const responseUser = await userEndpoints.getUserInformations(cdUsuarioSolicitacao);
      if (responseUser.status === 200 && responseUser.data) {
        const dataUser = responseUser.data;
        const tempName =
          dataUser.deRazaoSocial || dataUser.nmCompleto || dataUser.nmUsuario || '';
        const tempDocument = dataUser.deCnpjMatriz || dataUser.deCpfCnpj || dataUser.deCpf || '';

        return { name: tempName, document: tempDocument };
      }
    }
  } catch (error) {}
  return {};
};

export const {
  setCompanyTypes,
  clearCompanyTypes,
  setCompanyTypesGeneral,
  clearCompanyTypesGeneral,
  setPersonTypes,
  clearPersonTypes,
  setActiveCompany,
  clearActiveCompany,
  setIndustry,
  clearIndustry,
  setCompanyVehicles,
  clearCompanyVehicles,
  setCompanyInfractions,
  clearCompanyInfractions,
  setCompanyLicenses,
  clearCompanyLicenses,
  setCompanyLines,
  clearCompanyLines,
} = companySlice.actions;
export default companySlice;
